/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var About = "A propos de";
var Access = "Accès";
var Account = "Compte";
var Actions = "Actions";
var Active = "Active";
var Add = "Ajouter";
var Address = "Adresse";
var Advanced = "A l'avance";
var Aliases = "Alias";
var all = "tout";
var All = "Tous";
var Apply = "Appliquer";
var April = "Avril";
var Arbitrary = "Arbitrage";
var Assign = "Affecter";
var August = "Août";
var Back = "Retour";
var Basic = "Basic";
var BNPP_EU = "BNPP_EU";
var Cancel = "Annuler";
var Category = "Catégorie";
var Classic = "Classique";
var Clear = "Effacer";
var CLI = "Interface CLI";
var Close = "Fermer";
var Clusters = "Clusters";
var code = "code";
var Complete = "Terminé";
var Completed = "Opération terminée";
var Compliance = "Conformité";
var Compliant = "Conforme";
var Configuration = "Configuration";
var Configure = "Configurer";
var Confirm = "Confirmer";
var Connect = "Connect";
var Connected = "Connecté";
var Connecting = "Connexion en cours";
var Containers = "Conteneurs";
var Country = "Pays";
var Create = "Créer";
var Created = "Créé";
var Creating = "Création en cours";
var Critical = "Critique";
var Current = "En cours";
var Custom = "Custom";
var Dallas = "Dallas";
var Datacenter = "Centre de données";
var Datacenters = "Centres de données";
var December = "Décembre";
var Delete = "Supprimer";
var Deleting = "Suppression en cours";
var Deploying = "Déploiement";
var Disabled = "Désactivé";
var Disconnect = "Déconnecter";
var Docs = "Documents";
var Documentation = "Documentation";
var Done = "Done";
var Download = "Télécharger";
var Draft = "Brouillon";
var Edit = "Editer";
var Enabled = "Activé";
var Encryption = "Chiffrement";
var End = "Fin";
var Enterprise = "Entreprise";
var Establish = "Établir";
var Expired = "Arrivé à expiration";
var Failed = "Echec";
var February = "Février";
var Filter = "Filtre";
var Filters = "Filtres";
var Finalizing = "Finalisation";
var Frankfurt = "Francfort";
var Free = "Gratuit";
var Friday = "Vendredi";
var Geography = "Zone géographique";
var Help = "Aide";
var hour = "heure";
var Hour = "Heure";
var hr = "heure";
var IAM = "IAM";
var ID = "ID";
var Images = "Images";
var Inactive = "Inactif";
var Incomplete = "Incomplete";
var Information = "Informations";
var Infrastructure = "Infrastructure";
var Instance = "Instance";
var Instances = "Instances";
var Integrations = "Intégrations";
var Invalid = "Non valide";
var January = "Janvier";
var July = "Juillet";
var June = "Juin";
var Key = "Clé";
var Launch = "Lancer";
var Lite = "Lite";
var Loading = "Chargement en cours";
var Location = "Emplacement";
var Locations = "Emplacements";
var Logging = "Journalisation";
var London = "Londres";
var March = "Mars";
var May = "Mai";
var Metro = "Métropole";
var Minute = "Minute";
var mo = "mois";
var Monday = "Lundi";
var Monitoring = "Monitoring";
var Month = "Mois";
var more = "plus";
var Name = "Nom";
var Namespace = "Espace de nom";
var Namespaces = "Espaces de nom";
var Next = "Suivant";
var No = "Non";
var None = "Aucun";
var Normal = "Normal";
var Note = "Note";
var Notification = "Notification";
var November = "Novembre";
var Objects = "Objets";
var October = "Octobre";
var Off = "Désactivé";
var OK = "OK";
var On = "Activé";
var Open = "Ouvrir";
var Osaka = "Osaka";
var Overview = "Présentation";
var Packages = "Lots";
var Pattern = "Schéma";
var Pending = "En attente";
var Plan = "Plan";
var Premium = "Premium";
var Previous = "Précédent";
var Product = "Produit";
var Products = "Produits";
var Project = "Projet";
var Projects = "Projets";
var Property = "Propriété";
var provided = "fourni";
var Provider = "Fournisseur";
var Provisioning = "Mise à disposition en cours";
var Ready = "Prêt";
var Refresh = "Actualiser";
var region = "région";
var Region = "Région";
var Remove = "Retirer";
var Renew = "Renouveler";
var Repositories = "Référentiels";
var Requested = "Demandé";
var Required = "Obligatoire";
var Reservations = "Réservations";
var Reset = "Réinitialiser";
var resources = "ressources";
var Resources = "Ressources";
var Results = "Résultats";
var Review = "Passer en revue";
var Routing = "Routage";
var Satellite = "Satellite";
var Saturday = "Samedi";
var Save = "Sauvegarder";
var Scanning = "Analyse en cours...";
var Schedule = "Planifier";
var Search = "Rechercher";
var Secret = "Secret";
var Select = "Select";
var Sending = "Envoi";
var September = "Septembre";
var Serverless = "Sans serveur";
var Service = "Service";
var Settings = "Paramètres";
var Size = "Taille";
var Sort = "Trier";
var Source = "Source";
var Start = "Démarrer";
var State = "Etat";
var Status = "Statut";
var Storage = "Stockage";
var Submit = "Soumettre";
var Subscription = "Abonnement";
var Success = "Réussite";
var Summary = "Summary";
var Sunday = "Dimanche";
var Sydney = "Sydney";
var tag = "etiquette";
var tags = "étiquettes";
var Tags = "Balises";
var Thursday = "Jeudi";
var Tokyo = "Tokyo";
var Topics = "Rubriques";
var Toronto = "Toronto";
var Total = "Total";
var Trash = "Corbeille";
var Trial = "Essai";
var Tuesday = "Mardi";
var Unknown = "Inconnu";
var Unsupported = "Non pris en charge";
var Update = "Mettre à jour";
var Upgrade = "Mettre à niveau";
var Value = "Valeur";
var Values = "Valeurs";
var Version = "Version";
var View = "Afficher";
var Warning = "Avertissement";
var Wednesday = "Mercredi";
var Workloads = "Charges de travail";
var Yes = "Oui";
var Zone = "Zone";
var Zones = "Zones";
var fr = {
	"'{{namespace}}' already exists. Enter another name.": "'{{namespace}}' existe déjà. Entrez un autre nom.",
	"'Day of week' matches in addition to 'Day of month'": "'Jour de la semaine' correspond en plus de 'Jour du mois'",
	"'Day of week' matches in addition to 'Day of month'. The expression triggers every day.": "'Jour de la semaine' correspond en plus de 'Jour du mois'. L'expression se déclenche tous les jours.",
	"(IAM)": "(IAM)",
	"{{count}} items selected": "{{count}} éléments sélectionnés",
	"{{count}} resources": "{{count}} ressources",
	"{{count}} resources included": "{{count}} ressources incluses",
	"{{current}} of {{total}} pages": "{{current}} pages sur {{total}}",
	"{{datahookName}} response": "Réponse {{datahookName}}",
	"{{instance_name}} ( {{region}} )": "{{instance_name}} ( {{region}} )",
	"{{label}} patterns": "Modèles {{label}}",
	"{{min}}–{{max}} items": "{{min}} à {{max}} éléments",
	"{{min}}–{{max}} of {{total}} items": "{{min}} à {{max}} élément(s) sur {{total}}",
	"{{moduleCount}} modules, {{resourcesCount}} resources": "{{moduleCount}} modules, {{resourcesCount}} ressources",
	"{{name}} requires the following option(s) in order to deploy.": "{{name}} requiert les options suivantes pour être déployé.",
	"{{price}} per {{unit}}": "{{price}} par {{unit}}",
	"{{price}} per month": "{{price}} par mois",
	"{{price}}/{{unit}}": "{{price}}/{{unit}}",
	"{{price}}/mo": "{{price}}/mois",
	"{{resourcesCount}} resources": "{{resourcesCount}} ressources",
	"{{rolesCount}} Role": "{{rolesCount}} rôle",
	"{{rolesCount}} Roles": "{{rolesCount}} rôles",
	"{{topicsCount}} topic active for this instance.": "{{topicsCount}} rubrique active pour cette instance.",
	"{{topicsCount}} topics active for this instance.": "{{topicsCount}} rubriques actives pour cette instance.",
	"{{value}} percent status progress": "{{value}} pour cent de progression du statut",
	"{{version}} (create a new cluster to try out this beta version)": "{{version}} (créez un cluster pour tester cette version bêta)",
	"{{version}} (update to an earlier version first)": "{{version}} (migrez vers une version antérieure au préalable)",
	"<span>You must have a Cloud Object Storage instance to create a Satellite location.</span> <a>Learn more.</a>": "<span>Vous devez disposer d'une instance Cloud Object Storage pour créer un emplacement Satellite.</span> <a>En savoir plus.</a>",
	"$0.00": "$0.00",
	"$0.00 / instance": "$0.00 / instance",
	"1 item selected": "1 élément sélectionné",
	"1 of 1 page": "Page 1 sur 1",
	"1 role": "1 rôle",
	"1–1 of 1 item": "1–1 sur 1 élément",
	"A collection of keys that belong to your service instance.": "Collection de clés appartenant à votre instance de service.",
	"A key can only have 5 aliases.": "Une clé ne peut avoir que 5 alias.",
	"A Key Protect key": "Une clé Key Protect",
	"A location name is required. ": "Un nom d'emplacement est obligatoire. ",
	"A multi-tenant key management service. Create and manage cryptographic keys to encrypt data in your applications and control access to your data.": "Un service de gestion de clés multilocataire. Créez et gérez vos clés cryptographiques pour chiffrer les données de vos applications et contrôler l'accès à vos données.",
	"A name is required.": "Un nom est obligatoire.",
	"A rotation policy of 12 months is recommended": "Une politique de rotation de 12 mois est recommandée",
	"A service to service authorization is required between {{sourceServiceDisplayName}} and {{serviceDisplayName}} to associate the encryption key. Key Protect will create one with your consent. Or you can create one manually.": "Une autorisation de service à service est requise entre {{sourceServiceDisplayName}} et {{serviceDisplayName}} pour associer la clé de chiffrement. Key Protect en créera une avec votre accord. Vous pouvez également en créer une manuellement.",
	"A single-tenant key management service. Create and manage cryptographic keys with key vaulting that is provided by dedicated customer-controlled Hardware Security Module. ": "Un service de gestion de clés à un seul locataire. Créez et gérez vos clés cryptographiques avec un système de coffre-fort fourni par le module matériel de sécurité contrôlé par le client. ",
	"A tag can include only alphanumeric characters, spaces, underscores, dashes, periods and one colon.": "Une étiquette peut uniquement contenir des caractères alphanumériques, des espaces, des traits de soulignement, des tirets, des points et un signe deux-points.",
	"A tag cannot end with a colon.": "Une étiquette ne peut pas se terminer par un signe deux-points.",
	"A tag cannot include more than 128 characters.": "Une étiquette ne peut pas comporter plus de 128 caractères.",
	"A tag cannot start with a colon.": "Une étiquette ne peut pas commencer par un signe deux-points.",
	"A tag should not have spaces around a colon.": "Dans une étiquette, le signe deux-points ne doit pas être précédé ni suivi d'un espace.",
	About: About,
	Access: Access,
	"Access management tags": "Etiquettes de gestion des accès",
	"Access management tags (optional)": "Balises de gestion des accès (facultatif)",
	"Access management tags help you apply flexible access policies on specific resources.": "Les étiquettes de gestion des accès permettent d'appliquer des stratégies d'accès flexibles à des ressources spécifiques.",
	Account: Account,
	"Account type": "Type de compte",
	"Action required": "Action requise",
	Actions: Actions,
	Active: Active,
	"Active promotions": "Promotions actives",
	"Activity tracker event collection is enabled for this resource and sent to targets as defined by your routing configuration.": "La collecte d'événements Activity Tracker est activée pour cette ressource et envoyée aux cibles définies par votre configuration de routage.",
	"Activity tracker events": "Evénements Activity Tracker",
	"Activity tracking": "Suivi des activités",
	Add: Add,
	"Add a single namespace or multiple namespaces to your specific namespace's list.": "Ajoutez un ou plusieurs espaces de noms à votre liste d'espaces de noms spécifiques.",
	"Add a single project or multiple projects to your specific project's list.": "Ajoutez un ou plusieurs projets à votre liste de projets spécifiques.",
	"Add Activity tracker event collection": "Ajouter une collecte d'événements Activity Tracker",
	"Add activity tracking": "Ajouter un suivi d'activités",
	"Add event collection": "Ajouter une collecte d'événements",
	"Add hosts": "Ajouter des hôtes",
	"Add hosts to meet the minimum service requirements.": "Ajoutez des hôtes pour satisfaire aux exigences de service minimales.",
	"Add key alias (optional)": "Ajouter un alias de clé (facultatif)",
	"Add key description (optional)": "Ajouter une description de la clé (facultatif)",
	"Add logging": "Ajouter la journalisation",
	"Add monitoring": "Ajouter la surveillance",
	"Add namespace": "Ajouter un espace de noms",
	"Add New": "Ajouter un nouvel élément",
	"Add project": "Ajouter un projet",
	"Add storage": "Ajouter du stockage",
	"Add tags": "Ajouter des balises",
	"Add to estimate": "Ajouter à l'estimation",
	"Add to existing": "Ajouter à l'existant",
	"Add to project": "Ajouter au projet",
	"Adding ...": "Ajout en cours...",
	Address: Address,
	"Address any required actions below to successfully provision your service. You can complete these steps now, or after creating the service.": "Prenez en compte les actions requises ci-dessous pour mettre à disposition votre service. Vous pouvez effectuer ces étapes maintenant ou après avoir créé le service.",
	"Address field": "Zone d'adresse",
	Advanced: Advanced,
	"Advanced options": "Options avancées",
	"After connection": "Après la connexion",
	"After the service cluster is created, assign storage to the cluster.": "Une fois le cluster de service créé, affectez lui du stockage.",
	"After you disconnect Event Notifications, the {{serviceName}} instance is removed from the list of source services in the Event Notifications instance.": "Une fois que vous avez déconnecté Event Notifications, l'instance {{serviceName}} est supprimée de la liste des services source de l'instance Event Notifications.",
	Aliases: Aliases,
	"Aliases may only contain alphanumeric characters and -_.": "Les alias ne peuvent contenir que des caractères alphanumériques et -_.",
	"Aliases must be at least 2 characters and at most 90 characters.": "Les alias doivent comporter au moins 2 caractères et au maximum 90 caractères.",
	all: all,
	All: All,
	"All audit events (default target)": "Tous les événements d'audit (cible par défaut)",
	"All audit events from your account will be sent to a new instance": "Tous les événements d'audit de votre compte seront envoyés à une nouvelle instance",
	"All audit events from your account will be sent to an existing instance": "Tous les événements d'audit de votre compte seront envoyés à une instance existante",
	"All namespaces": "Tous les espaces de noms",
	"All namespaces not supported": "Tous les espaces de noms non pris en charge",
	"All platform logs": "Tous les journaux de la plateforme",
	"All prerequisite services are installed on the location.": "Tous les services prérequis sont installés à l'emplacement.",
	"All projects": "Tous les projets",
	"All projects not supported": "Tous les projets non pris en charge",
	"All regions": "Toutes les régions",
	"All resource groups": "Tous les groupes de ressources",
	"All secret groups": "Tous les groupes de secrets",
	"All types": "Tous les types",
	"All zone names must be unique": "Tous les noms de zone doivent être uniques",
	"Allowed actions for the {{roleName}} role ({{actionCount}})": "Actions autorisées pour le rôle {{roleName}} : ({{actionCount}})",
	"Already have an account? <a>Log in</a>": "Vous avez déjà un compte ? <a>Connectez-vous</a>",
	"An error occurred when fetching secrets. Try again later.": "Une erreur s'est produite lors de l'extraction de secrets. Réessayez ultérieurement.",
	"An instance of Event Notifications <a>Create new instance</a>": "Une instance de Notifications d'événement <a>Créer une nouvelle instance</a>",
	"An unexpected error occurred.": "Une erreur inattendue s'est produite.",
	"Analyze and manage logs for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>": "Analyser et gérer les journaux pour une résolution rapide des problèmes et une prévention proactive des temps d'arrêt. <a>En savoir plus</a>",
	Apply: Apply,
	"Apply a code": "Appliquer un code",
	April: April,
	Arbitrary: Arbitrary,
	"Are you sure that you want to disconnect {{serviceName}} instance from the \"{{ENInstanceName}}\" instance?": "Êtes-vous sûr de vouloir déconnecter l'instance {{serviceName}} de l'instance \"{{ENInstanceName}}\" ?",
	"Are you sure you want to close the side panel?": "Êtes-vous sûr de vouloir fermer le panneau latéral ?",
	"Are you sure you want to close this panel? Any selections you have made will be lost.": "Voulez-vous fermer ce panneau ? Toutes les sélections effectuées seront perdues.",
	"Are you sure?": "Confirmez-vous ?",
	Assign: Assign,
	"Associate key": "Associer la clé",
	"Attachment name": "Nom de connexion",
	"Audit event collection is already enabled for this resource": "La collecte des événements d'audit est déjà activée pour cette ressource",
	"Audit event collection is recommended for optimal troubleshooting and reducing downtime": "La collecte d'événements d'audit est recommandée pour optimiser le dépannage et réduire les temps d'arrêt",
	"Audit events (error)": "Événements d'audit (erreur)",
	"Audit events from {{region}} will be sent to a new instance": "Les événements d'audit de {{region}} seront envoyés à une nouvelle instance",
	"Audit events from {{region}} will be sent to an existing instance": "Les événements d'audit de {{region}} seront envoyés à une instance existante",
	"Audit events in {{region}}": "Événements d'audit de {{region}}",
	"Audit events will be collected from enabled IBM Cloud services according to the defined routing scope.": "Les événements d'audit seront collectés à partir des services IBM Cloud activés, conformément à la portée de routage définie.",
	"Audit events...": "Événements d'audit...",
	August: August,
	"Authentication is required or you do not have the correct permissions to perform this action.": "Une authentification est requise ou vous ne disposez pas des droits nécessaires pour effectuer cette action.",
	"Authorization error": "Erreur d'autorisation",
	"Authorization met": "Autorisation satisfaite",
	"Authorization needed": "Autorisation requise",
	"Authorize now": "Autoriser maintenant",
	"Authorizing...": "Autorisation...",
	Back: Back,
	"Base URI": "URI de base",
	"Base64 encoded key material": "Matériau de clé codé en Base64",
	Basic: Basic,
	"Before you begin": "Avant de commencer",
	"Before your project can validate or deploy configurations, the Projects service needs to be authorized in this account to communicate with Schematics, Catalog Management, Secrets Manager, and Resource Controller. A user with the required access to those services can automatically grant authorizations by creating a project in this account, or they can create the service to service authorizations manually. This authorization is only required once.": "Pour que votre projet puisse valider ou déployer des configurations, le service Projets doit être autorisé sur ce compte à communiquer avec Schematics, la gestion du catalogue, Secrets Manager et le contrôleur de ressources. Un utilisateur disposant de l'accès requis à ces services peut accorder automatiquement des autorisations en créant un projet sur ce compte ou créer les autorisations de service à service manuellement. Cette autorisation n'est requise qu'une seule fois.",
	"Billing information": "Informations sur la facturation",
	"Billing period": "Période de facturation",
	BNPP_EU: BNPP_EU,
	"Bucket name": "Nom du compartiment",
	"By {{name}}": "Par {{name}}",
	"By clicking Save, you are creating the following access:": "En cliquant sur Enregistrer, vous créez l'accès suivant :",
	"Can't retrieve details": "Impossible d'extraire les détails",
	Cancel: Cancel,
	"Cannot list integrations!": "Impossible de répertorier les intégrations !",
	"Cannot view keys in this instance": "Impossible d'afficher les clés de cette instance",
	Category: Category,
	"Charges apply. <a>Learn more</a>": "Des frais s'appliquent. <a>En savoir plus</a>",
	"Choose a cluster version": "Choisir une version de cluster",
	"Choose a key ring": "Choisir un fichier de clés",
	"Choose a resource group": "Choisir un groupe de ressources",
	"Choose account...": "Choisir un compte...",
	"Choose an existing HPCS instance.": "Choisissez une instance HPCS existante.",
	"Choose an existing Key Protect instance.": "Choisissez une instance Key Protect existante.",
	"Choose an instance": "Choisir une instance",
	"Choose an option": "Sélectionner une option",
	"Choose category...": "Choisissez une catégorie...",
	"Choose location": "Choisir l'emplacement",
	"Choose plan": "Choisir un plan",
	"Choose property...": "Choisissez une propriété...",
	"Choose provider...": "Choisir un fournisseur...",
	"Choose secret...": "Choisir un secret...",
	"Choose service instance...": "Choisir une instance de service...",
	"Choose source name...": "Choisissez le nom de la source...",
	"Choose source...": "Choisissez la source...",
	"Choose which IBM Cloud Monitoring instance will receive platform metrics from enabled service instances across IBM Cloud.": "Choisissez l'instance IBM Cloud Monitoring qui recevra des métriques de plateforme des instances de service activées dans IBM Cloud.",
	"Choose which IBM Log Analysis instance will receive platform logs from enabled service instances across IBM Cloud.": "Choisissez l'instance IBM Log Analysis qui recevra des journaux de plateforme d'instances de service activées dans IBM Cloud.",
	Classic: Classic,
	Clear: Clear,
	"Clear all": "Tout effacer",
	"Clear all selected items": "Effacer tous les éléments sélectionnés",
	"Clear filters": "Effacer les filtres",
	"Clear selected": "Effacer les éléments sélectionnés",
	"Clear selected item": "Effacer l'élément sélectionné",
	"Clear selection": "Effacer la sélection",
	CLI: CLI,
	Close: Close,
	"Close menu": "Fermer le menu",
	"Close page navigation menu": "Fermer le menu de navigation par page",
	"Close Panel": "Fermer le panneau",
	"Close Push Panel": "Fermer le panneau Push",
	"Closing side panel": "Fermeture du panneau latéral",
	"Cloud Logs": "Journaux cloud",
	"Cloud Logs instance": "Instance Cloud Logs",
	"Cloud Logs instance name": "Nom de l'instance Cloud Logs",
	"Cloud Object Storage": "Cloud Object Storage",
	"Cloud Object Storage instance": "Instance Cloud Object Storage",
	"Cluster \"{{name}}\" is being deleted.": "Le cluster \"{{name}}\" est en cours de suppression.",
	"Cluster management": "Gestion des clusters",
	"Cluster version": "Version du cluster",
	"Cluster version cannot be updated.": "La version du cluster ne peut pas être mise à jour.",
	Clusters: Clusters,
	code: code,
	"Code sample": "Exemple de code",
	"Collapse all rows": "Réduire toutes les lignes",
	"Collapse group": "Réduire le groupe",
	"Collapse row": "Réduire la ligne",
	"Collapse summary": "Réduire le récapitulatif",
	"Compact (24px)": "Taille compacte (24 px)",
	Complete: Complete,
	Completed: Completed,
	Compliance: Compliance,
	Compliant: Compliant,
	Configuration: Configuration,
	"Configuration details": "Détails de configuration",
	"Configuration name": "Nom de configuration",
	Configure: Configure,
	"Configure activity tracking": "Configurer le suivi des activités",
	"Configure encryption": "Configurer le chiffrement",
	"Configure logging": "Configurer la journalisation",
	"Configure monitoring": "Configurer la surveillance",
	Confirm: Confirm,
	Connect: Connect,
	"Connect to Event Notifications": "Connexion à Event Notifications",
	"Connect your {{serviceName}} instance to an existing Event Notifications instance.": "Connectez votre instance {{serviceName}} à une instance Event Notifications existante.",
	Connected: Connected,
	"Connected instance": "Instance connectée",
	"Connected instance of Event Notifications does not exist. Contact your administrator.": "L'instance connectée d'Event Notifications n'existe pas. Contactez votre administrateur.",
	Connecting: Connecting,
	"Contact your account administrator to access a plan to provision Key Protect.": "Contactez votre administrateur de compte pour accéder à un plan de mise à disposition de Key Protect.",
	"Contact your account administrator to access a resource group to provision Key Protect.": "Contactez votre administrateur de compte pour accéder à un groupe de ressources afin de mettre à disposition Key Protect.",
	"Contact your administrator for access.": "Contactez votre administrateur pour y accéder.",
	"Contact your administrator for additional assistance.": "Prenez contact avec votre administrateur pour obtenir de l'aide supplémentaire.",
	"Container registry": "Registre de conteneurs",
	Containers: Containers,
	"Copied to clipboard": "Copié dans le presse-papiers",
	"Copy to clipboard": "Copier dans le presse-papiers",
	"Cost details": "Détails sur le coût",
	"costctr:124": "costctr:124",
	"Could not load pricing information. Refresh the page or try again later.": "Impossible de charger les informations de tarification. Actualisez la page ou réessayez ultérieurement.",
	Country: Country,
	Create: Create,
	"Create a key": "Créer une clé",
	"Create a Logs routing target to support log management and analysis for rapid issue resolution and proactive downtime prevention. <a>Learn more</a>": "Créez une cible de routage des journaux pour prendre en charge la gestion et l'analyse des journaux en vue d'une résolution rapide des problèmes et d'une prévention proactive des temps d'arrêt. <a>En savoir plus</a>",
	"Create a new instance to get started.": "Créez une nouvelle instance pour commencer.",
	"Create a project": "Créer un projet",
	"Create a Satellite location to bring IBM Cloud anywhere. For more information, <a>see the documentation.</a>": "Créez un emplacement Satellite pour amener IBM Cloud n'importe où. Pour plus d'informations, <a>voir la documentation.</a>",
	"Create an Activity tracker event routing target and route to support monitoring and auditing IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>": "Créez une cible de routage d'événement Activity Tracker et une route pour prendre en charge la surveillance et l'audit de l'activité IBM Cloud pour une sécurité et une conformité accrues. <a>En savoir plus</a>",
	"Create an encryption key or import your own key.": "Créez une clé de chiffrement ou importez votre propre clé.",
	"Create cluster": "Créer un cluster",
	"Create failed": "Echec de la création",
	"Create instance": "Créer une instance",
	"Create location": "Créer un emplacement",
	"Create new": "Créer",
	"Create new instance": "Créer une instance",
	"Create new key": "Créer une clé",
	"Create new secret": "Créer un secret",
	"Create reference": "Créer une référence",
	"Create resource": "Créer une ressource",
	"Create Satellite location": "Créer un emplacement Satellite",
	"Create secret": "Créer un secret",
	"Create services": "Création de services",
	"Create Topics, Destinations and Subscriptions in Event Notifications to be notified of events that are generated by your {{serviceName}}": "Créez des rubriques, des destinations et des abonnements dans Event Notifications pour être averti des événements générés par votre {{serviceName}}",
	Created: Created,
	Creating: Creating,
	"Creating ...": "Création...",
	"Creating...": "Création en cours...",
	Critical: Critical,
	"CRON expression": "Expression CRON",
	Current: Current,
	Custom: Custom,
	"Custom access": "Accès personnalisé",
	Dallas: Dallas,
	"dashlet.title": "dashlet.title",
	Datacenter: Datacenter,
	Datacenters: Datacenters,
	"Datahook argument block": "Bloc d'arguments de datahook",
	"Datahook Params": "Paramètres de datahook",
	"Datahook response": "Réponse de datahook",
	"Day of month": "Jour du mois",
	"Day of Month (UTC)": "Jour du mois (UTC)",
	"Day of week": "Jour de la semaine",
	"Day of week (UTC)": "Jour de la semaine (UTC)",
	December: December,
	"Dedicated hosts": "Hôtes dédiés",
	"Default target": "Cible par défaut",
	"Default title": "Titre par défaut",
	"Define project details": "Définir les détails du projet",
	"Define the recurring timings of the events generated by this event. Select a predefined pattern and customize it to your needs. Schedules are specified in Coordinated Universal Time (UTC).": "Définissez les délais récurrents des événements générés par cet événement. Sélectionnez un schéma prédéfini et personnalisez-le en fonction de vos besoins. Les plannings sont spécifiés en temps universel coordonné (UTC).",
	"Define the scope of audit events collected": "Définir la portée des événements d'audit collectés",
	Delete: Delete,
	"Delete cluster": "Supprimer le cluster",
	"Delete failed": "Echec de la suppression",
	"Delete retry wait": "Attente de nouvelle tentative de suppression",
	"Delete the persistent storage used by this cluster": "Supprimer le stockage de persistance utilisé par ce cluster",
	Deleting: Deleting,
	"Deleting...": "Suppression en cours...",
	"Deploy failed": "Echec du déploiement",
	"Deploy retry wait": "Attente de nouvelle tentative de déploiement",
	Deploying: Deploying,
	"Deployment ready": "Déploiement prêt",
	"Deprecated version, support will end {{when}}. Update the version to continue to receive support.": "Version obsolète, sa prise en charge se terminera {{when}}. Mettez à jour la version pour continuer à bénéficier du support.",
	"Description (optional)": "Description (facultatif)",
	"Description of the source": "Description de la source",
	Disabled: Disabled,
	Disconnect: Disconnect,
	"Disconnect Event Notifications": "Déconnecter Event Notifications",
	"DNS subdomain labels must be no more than {{maxLength}} characters.": "Les libellés de sous-domaine DNS ne doivent pas comporter plus de {{maxLength}} caractères.",
	Docs: Docs,
	Documentation: Documentation,
	Done: Done,
	"Done editing": "Edition terminée",
	Download: Download,
	Draft: Draft,
	"During the update, your cluster master, worker nodes, apps, and resources continue to run. After the update is complete, you can update your worker node versions. For instructions and more information about differences across versions, <a>review the docs</a>.": "Lors de la mise à jour, votre maître cluster, vos noeuds worker, vos applications et vos ressources poursuivent leur exécution. Une fois la mise à jour terminée, vous pouvez mettre à jour les versions de votre noeud worker. Pour obtenir des instructions et plus d'informations sur les différences entre les versions, <a>consultez la documentation</a>.",
	Edit: Edit,
	"Edit activity tracker integration": "Modifier l'intégration d'Activity Tracker",
	"Edit Array": "Editer un tableau",
	"Edit columns": "Editer les colonnes",
	"Edit configuration": "Editer la configuration",
	"Edit details": "Editer les détails",
	"Edit JSON": "Editer le JSON",
	"Edit logging integration": "Modifier Intégration de la journalisation",
	"Edit secure value": "Editer la valeur sécurisée",
	"Edit tags": "Editer les étiquettes",
	"Enable lifecycle notifications for your {{serviceName}} instance by connecting an Event Notifications service instance.": "Activez les notifications de cycle de vie pour votre instance {{serviceName}} en connectant une instance de service Event Notifications.",
	Enabled: Enabled,
	"Enables supervision, compliance, and audits the operations and risk to manage your IBM Cloud account.": "Permet la supervision, la conformité, et effectue l'audit des opérations et des risques pour gérer votre compte IBM Cloud.",
	Encryption: Encryption,
	"Encryption key associated": "Clé de chiffrement associée",
	"Encryption options menu": "Menu des options de chiffrement",
	End: End,
	"End date": "Date de fin",
	"Enhance your Schematics experience with integrations. Start adding integrations today by selecting from one of the options below.": "Améliorez votre expérience de Schematics avec les intégrations. Commencez à ajouter des intégrations dès aujourd'hui en sélectionnant l'une des options ci-dessous.",
	"Enter a name for the configuration of the deployable architecture.  For example: production-vpc": "Entrez un nom pour la configuration de l'architecture déployable.  Par exemple : production-vpc",
	"Enter a password": "Entrer un mot de passe",
	"Enter a valid CRN": "Saisir un CRN valide",
	"Enter array values. Quotations are added to values after you save.": "Entrez des valeurs de tableau. Les guillemets sont ajoutés aux valeurs après l'enregistrement.",
	"Enter name and description": "Entrez le nom et la description",
	"Enter names for the host zones. For high availability, allocate your hosts across these three zones based on your infrastructure provider zones. <a>Why do I need zones?</a>": "Entrez des noms pour les zones hôte. Pour une haute disponibilité, allouez vos hôtes sur ces trois zones en fonction des zones de votre fournisseur d'infrastructure. <a>A quoi servent les zones ?</a>",
	"Enter namespaces separated by a comma. After you click Add, the new namespaces are included in the list and automatically selected.": "Entrez des espaces de noms séparés par une virgule. Après avoir cliqué sur Ajouter, les nouveaux espaces de noms sont inclus dans la liste et sélectionnés automatiquement.",
	"Enter projects separated by a comma. After you click Add, the new projects are included in the list and automatically selected.": "Entrez des projets séparés par une virgule. Après avoir cliqué sur Ajouter, les nouveaux projets sont inclus dans la liste et sélectionnés automatiquement.",
	"Enter source name": "Entrer un nom de source",
	"Enter the exact name of an existing bucket in your Cloud Object Storage instance. If no name is provided, a new bucket is created for you.": "Entrez le nom exact d'un compartiment existant dans votre instance Cloud Object Storage. Si aucun nom n'est fourni, un nouveau compartiment est créé pour vous.",
	Enterprise: Enterprise,
	"Entire secret": "Secret entier",
	"Environment (optional)": "Environnement (facultatif)",
	"Environments can contain properties that are shared across related configurations. Within the configuration, you can override any values that are provided by the environment. <a>Learn more</a>": "Les environnements peuvent contenir des propriétés qui sont partagées entre les configurations associées. Dans la configuration, vous pouvez remplacer les valeurs fournies par l'environnement. <a>En savoir plus</a>",
	"Error": "Erreur",
	"Error checking existing services status": "Erreur lors de la vérification du statut des services existants",
	"Error checking host status": "Erreur lors de la vérification du statut de l'hôte",
	"Error checking storage status": "Erreur lors de la vérification du statut du stockage",
	"Error fetching tags": "Erreur lors de l'extraction des étiquettes",
	"Error icon": "Icône d'erreur",
	"Error loading accounts": "Erreur lors du chargement des comptes",
	"Error loading categories": "Erreur lors du chargement des catégories",
	"Error loading groups": "Erreur lors du chargement des groupes",
	"Error loading instances": "Erreur lors du chargement des instances",
	"Error loading keys": "Erreur lors du chargement des clés",
	"Error loading pricing": "Erreur lors du chargement de la tarification",
	"Error loading properties": "Erreur lors du chargement des propriétés",
	"Error loading providers": "Erreur lors du chargement des fournisseurs",
	"Error loading regions": "Erreur lors du chargement des régions",
	"Error loading resource groups": "Erreur lors du chargement des groupes de ressources",
	"Error loading S2S auth": "Erreur lors du chargement de l'authentification S2S",
	"Error loading secrets": "Erreur lors du chargement des secrets",
	"Error loading source names": "Erreur lors du chargement des noms de source",
	"Error loading sources": "Erreur lors du chargement des sources",
	"Error loading types": "Erreur lors du chargement des types",
	"Error validating this code. Please make sure you don't include any quotation marks in the promo code.": "Une erreur s'est produite lors de la validation de ce code. Veillez à ne pas inclure de guillemets dans le code promo.",
	Establish: Establish,
	"Estimate costs": "Coûts estimés",
	"Estimated cost per instance": "Coût estimé par instance",
	"Estimated starting cost": "Coût de départ estimé",
	"Estimated total ({{count}} instances)": "Total estimé ({{count}} instances)",
	"Event Notifications": "Event Notifications",
	"Event Notifications instance": "Instance d'Event Notifications",
	"Event Notifications service instance": "Instance de service Event Notifications",
	"Event Source Manager": "Gestionnaire de sources d'événements",
	"Every 2 hours": "Toutes les 2 heures",
	"Every 2 minutes": "Toutes les 2 minutes",
	"Every 3 hours": "Toutes les 3 heures",
	"Every 4 hours": "Toutes les 4 heures",
	"Every 5 minutes": "Toutes les 5 minutes",
	"Every 6 hours": "Toutes les 6 heures",
	"Every 10 minutes": "Toutes les 10 minutes",
	"Every 15 minutes": "Toutes les 15 minutes",
	"Every day": "Tous les jours",
	"Every fifth day": "Tous les cinq jours",
	"Every fourth day": "Tous les quatre jours",
	"Every fourth month": "Tous les quatre mois",
	"Every hour": "Toutes les heures",
	"Every minute": "Toutes les minutes",
	"Every month": "Tous les mois",
	"Every second day": "Tous les deux jours",
	"Every second month": "Tous les deux mois",
	"Every sixth month": "Tous les six mois",
	"Every third day": "Tous les trois jours",
	"Every third month": "Tous les trois mois",
	"Examples: access:dev, proj:version-1": "Exemples : access:dev, proj:version-1",
	"Examples: env:dev, version-1": "Exemples : env:dev, version-1",
	"Existing instance": "Instance existante",
	"Exiting encryption selection": "Quitter la sélection du chiffrement",
	"Expand all rows": "Développer toutes les lignes",
	"Expand group": "Développer le groupe",
	"Expand row": "Développer la ligne",
	"Expand summary": "Développer le récapitulatif",
	Expired: Expired,
	"Expired (beta)": "Arrivé à expiration (version bêta)",
	"Expires {{when}}": "Expire {{when}}",
	"Expires after beta": "Expire après la version bêta",
	"Extra large (64px)": "Très grand (64px)",
	"Extra small (24px)": "Très petit (24px)",
	Failed: Failed,
	"Failed to check permission": "Échec de la vérification de l'autorisation",
	"Failed to create configuration": "Échec de la création de la configuration",
	"Failed to create key": "Échec de création de la clé",
	"Failed to create policy": "Echec de la création de la règle",
	"Failed to create project": "Échec de la création du projet",
	"Failed to fetch": "Echec de l'extraction",
	"Failed to fetch IBM Cloud Activity Tracker instances.": "Echec d'extraction d'instances IBM Cloud Activity Tracker.",
	"Failed to fetch IBM Cloud Monitoring instances.": "Echec d'extraction d'instances IBM Cloud Monitoring.",
	"Failed to fetch IBM Log Analysis instances.": "Echec d'extraction d'instances IBM Log Analysis.",
	"failure state": "état d'échec",
	February: February,
	"Fetch data": "Extraire les données",
	Filter: Filter,
	"Filter instance by region": "Filtrer l'instance par région",
	"Filter...": "Filtrer...",
	Filters: Filters,
	"Filters:": "Filtres :",
	Finalizing: Finalizing,
	"Finalizing cluster...": "Finalisation du cluster...",
	"Finalizing workers...": "Finalisation des noeuds worker...",
	Frankfurt: Frankfurt,
	Free: Free,
	Friday: Friday,
	Geography: Geography,
	"Get operational visibility into your Cloud resources with IBM Cloud Activity Tracker.": "Bénéficiez d'une visibilité opérationnelle sur vos ressources Cloud à l'aide d'IBM Cloud Activity Tracker.",
	"Get operational visibility into your Cloud resources with IBM Cloud Monitoring.": "Bénéficiez d'une visibilité opérationnelle sur vos ressources Cloud à l'aide d'IBM Cloud Monitoring.",
	"Get operational visibility into your Cloud resources with IBM Log Analysis.": "Bénéficiez d'une visibilité opérationnelle sur vos ressources Cloud à l'aide d'IBM Log Analysis.",
	"Get started": "Premiers pas",
	"Get started with Security and Compliance Center": "Initiation à Security and Compliance Center",
	"Give your key an alias for easy retrieval later.": "Donnez un alias à votre clé pour la retrouver plus facilement par la suite.",
	"Helm catalog": "Catalogue Helm",
	Help: Help,
	"Hide password": "Masquer le mot de passe",
	"Host usage\n(used / total)": "Utilisation hôte (utilisé/total)",
	"Hosts needed": "Hôtes requis",
	"Hosts requirements met": "Conditions requises pour les hôtes satisfaites",
	hour: hour,
	Hour: Hour,
	"Hour (UTC)": "Heure (UTC)",
	hr: hr,
	"Hyper Protect Crypto Services": "Hyper Protect Crypto Services",
	"I agree to use my token to create a service to service policy between source service {{sourceServiceDisplayName}} and target service {{serviceDisplayName}} on my behalf.": "J'accepte d'utiliser mon jeton pour créer une règle de service à service entre le service source {{sourceServiceDisplayName}} et le service cible {{serviceDisplayName}} en mon nom.",
	"I confirm that I want to stop receiving platform logs from {{instance}}": "Je confirme souhaiter ne plus recevoir les journaux de plateforme de {{instance}}",
	"I confirm that I want to stop receiving platform metrics from {{instance}}": "Je confirme souhaiter ne plus recevoir les métriques de plateforme de {{instance}}",
	"IaaS ready": "IaaS prêt",
	IAM: IAM,
	"IAM credentials": "Données d'identification IAM",
	"IBM Cloud": "IBM Cloud",
	"IBM Cloud Activity Tracker": "IBM Cloud Activity Tracker",
	"IBM Cloud Monitoring": "IBM Cloud Monitoring",
	"IBM Cloud Satellite": "IBM Cloud Satellite",
	"IBM Log Analysis": "IBM Log Analysis",
	ID: ID,
	"ID: {{incidentId}}": "ID : {{incidentId}}",
	"If no key ring is assigned, key will be added to the default key ring.": "Si aucun fichier de clés n'est affecté, la clé sera ajoutée au fichier de clés par défaut.",
	"If selected, the array will be saved as \"__NOT_SET__\" string.": "Si cette option est sélectionnée, le tableau sera sauvegardé en tant que chaîne \"__NOT_SET__\".",
	"If the initial value was not a valid string array, an empty or single item array will appear below.": "Si la valeur initiale n'était pas un tableau de chaînes valides, un tableau d'éléments vides ou uniques apparaît ci-dessous.",
	"If your user tags are billing related, consider writing tags as key:value pairs, such as": "Si vos étiquettes utilisateur sont liées à la facturation, pensez à les créer sous la forme de paires clé:valeur, comme",
	Images: Images,
	"Import your own key": "Importer votre propre clé",
	"In progress": "En cours",
	"in progress state": "état en cours",
	Inactive: Inactive,
	"inactive state": "état inactif",
	Incomplete: Incomplete,
	"incomplete state": "état incomplet",
	Information: Information,
	"information state": "état des informations",
	Infrastructure: Infrastructure,
	"Infrastructure zones": "Zones d'infrastructure",
	Instance: Instance,
	"Instance ID": "ID d'instance",
	"Instance location": "Emplacement de l'instance",
	"Instance name": "Nom d'instance",
	"Instance(s) in {{region}}": "Instance(s) dans {{region}}",
	"Instance(s) in region": "Instance(s) dans la région",
	Instances: Instances,
	Integrations: Integrations,
	"Internal server error. Wait a minute and try your action again. If the issue persists, open a support ticket.": "Erreur de serveur interne. Attendez une minute et relancez l'opération. Si le problème persiste, ouvrez un ticket de demande de service.",
	"Interpolated URI": "URI interpolé",
	Invalid: Invalid,
	"Invalid datahook object, using last valid options": "Objet datahook non valide : utilisation des dernières options valides.",
	"Invalid label name.": "Nom de libellé incorrect.",
	"Invalid label prefix or name.": "Préfixe ou nom de libellé non valide.",
	"Invalid label value.": "Valeur de libellé non valide.",
	"Items per page:": "Eléments par page :",
	January: January,
	July: July,
	June: June,
	Key: Key,
	"Key aliases": "Principaux alias",
	"Key CRN": "Nom de ressource de cloud de la clé",
	"Key description": "Description de la clé",
	"Key description must be at least 2 characters and no more than 240 characters.": "La description de la clé doit comporter au moins 2 caractères et pas plus de 240 caractères.",
	"Key ID": "ID de la clé",
	"Key management": "Gestion des clés",
	"Key management service": "Service de gestion des clés",
	"Key material": "Informations de clé",
	"Key material is required to import a key": "Les informations de clé sont requises pour importer une clé",
	"Key material length must be 128, 192, or 256 bits": "La longueur des informations de clé doit être de 128, 192 ou 256 bits",
	"Key material must be base64": "Les informations de clé doivent être en base64",
	"Key name": "Nom de la clé",
	"Key Protect": "Key Protect",
	"Key Protect instance name": "Nom d'instance Key Protect",
	"Key ring": "Fichier de clés",
	"Key value": "Valeur de clé",
	"Label must be of the form 'key:value'.": "Le libellé doit être de la forme 'clé:valeur'.",
	"Label name must be no more than {{maxLength}} characters.": "Le nom de libellé ne doit pas comporter plus de {{maxLength}} caractères.",
	"Label prefix must be a valid DNS subdomain.": "Le préfixe de libellé doit être un sous-domaine DNS valide.",
	"Label prefix must be no more than {{maxLength}} characters.": "Le préfixe de libellé ne doit pas comporter plus de {{maxLength}} caractères.",
	"Label value must be no more than {{maxLength}} characters.": "La valeur de libellé ne doit pas comporter plus de {{maxLength}} caractères.",
	"Large (48px)": "Grand (48px)",
	"Last modified": "Dernière modification",
	"Last scanned": "Dernière analyse",
	"Last updated": "Dernière mise à jour",
	Launch: Launch,
	"Launch activiting tracking": "Lancer le suivi des actions",
	"Launch in new window": "Lancer dans une nouvelle fenêtre",
	"Launch logging": "Lancer la journalisation",
	"Launch monitoring": "Lancer la surveillance",
	"Learn more": "En savoir plus",
	"learn more.": "en savoir plus.",
	"Learn more.": "En savoir plus.",
	"List of actions": "Liste des actions",
	"list of code sample types": "liste des types d'exemple de code",
	Lite: Lite,
	Loading: Loading,
	"Loading indicator": "Indicateur de chargement",
	"Loading...": "Chargement en cours...",
	"Locate by CRN within your account": "Localiser par CRN dans votre compte",
	Location: Location,
	"Location summary": "Récapitulatif de l'emplacement",
	"Location:": "Emplacement :",
	Locations: Locations,
	"Log collection is already enabled for this resource": "La collecte de journaux est déjà activée pour cette ressource",
	"Log collection is enabled for this resource and sent to targets as defined by your routing configuration.": "La collecte des journaux est activée pour cette ressource et envoyée aux cibles définies par votre configuration de routage.",
	Logging: Logging,
	"Logging (error)": "Journalisation (erreur)",
	"Logging is recommended for optimal troubleshooting and reducing downtime": "La journalisation est recommandée pour optimiser le dépannage et réduire les temps d'arrêt",
	"Logging...": "Journalisation...",
	London: London,
	"Looking for valid service to service authorization policy...": "Recherche d'une politique d'autorisation de service à service valide...",
	"Looks like you are missing the required permissions to create the policy. Contact your account administrator": "Il semble que vous n'ayez pas les autorisations requises pour créer la règle. Contactez votre administrateur de compte",
	"Looks like you don't have access to view account information.": "Il semble que vous ne disposiez pas des droits d'accès permettant d'afficher les informations sur le compte.",
	"Looks like you don't have access to view the billing period": "Il semble que vous n'avez pas accès à la période de facturation",
	"Looks like you don't have any scans": "Il semble que vous n'avez pas d'analyses.",
	"Looks like you don't have the access needed to view this information. Contact your account administrator to verify your permissions.": "Il semble que vous ne disposez pas de l'accès nécessaire pour afficher ces informations. Contactez votre administrateur de compte pour vérifier vos droits.",
	"Looks like you don't have the correct access": "Il semble que vous ne disposiez pas des droits d'accès appropriés",
	"Looks like you don't have the correct access. You must have access to the target service to create an authorization between services.": "Il semble que vous ne disposiez pas de l'accès correct. Vous devez avoir accès au service cible pour créer une autorisation entre des services.",
	"Make sure you have Topics, Subscriptions and Destinations setup in Event Notifications.": "Vérifiez que les rubriques, les abonnements et les destinations sont configurés dans Event Notifications.",
	"Manage encryption by enabling a key management service (KMS).": "Gérer le chiffrement en activant un service de gestion des clés (KMS).",
	"Manage routing": "Gérer le routage",
	"Manage the lifecycle of your encryption keys that are used for you IBM Cloud resources, services, and applications.": "Gérez le cycle de vie des clés de chiffrement utilisées pour vos ressources, services et applications IBM Cloud.",
	"Managed from": "Géré depuis",
	March: March,
	May: May,
	"Media gallery video": "Vidéo de la médiathèque",
	"Medium (40px)": "Moyen (40px)",
	"Metadata location": "Emplacement des métadonnées",
	Metro: Metro,
	"Minimum host requirements are met.": "Les exigences minimales en matière d'hôtes sont satisfaites.",
	Minute: Minute,
	"Minute (UTC)": "Minute (UTC)",
	"Missing prerequisite services": "Services prérequis manquants",
	mo: mo,
	"Modify the arguments passed into your datahook here.": "Modifiez ici les arguments transmis à votre datahook.",
	"Mon-Fri": "Lundi au vendredi",
	Monday: Monday,
	"Monitor all of your environments for compliance by setting up scans.": "Surveillez la conformité de tous vos environnements en configurant des analyses.",
	"Monitor and audit IBM Cloud activity for enhanced security and compliance. <a>Learn more</a>": "Surveiller et auditer l'activité IBM Cloud pour une sécurité et une conformité accrues. <a>En savoir plus</a>",
	Monitoring: Monitoring,
	Month: Month,
	"Month (UTC)": "Mois (UTC)",
	more: more,
	Name: Name,
	"Name already in use. Provide a unique name.": "Nom déjà utilisé. Indiquez un nom unique.",
	"Name must be between 2 and 90 characters": "Le nom doit comporter entre 2 et 90 caractères",
	"Name this project": "Nommer ce projet",
	Namespace: Namespace,
	Namespaces: Namespaces,
	"New instance": "Nouvelle instance",
	Next: Next,
	"Next page": "Page suivante",
	"Next: Customize": "Suivant : Personnaliser",
	"nmpc-1, namespc-2": "nmpc-1, namespc-2",
	No: No,
	"No available catalog regions": "Aucune région de catalogue disponible",
	"No Cloud Object Storage instance is available.": "Aucune instance Cloud Object Storage n'est disponible.",
	"No code preview has been configured for terraform. Please visit our docs to ": "Aucun aperçu du code n'a été configuré pour Terraform. Consultez nos documents pour ",
	"No configurations available": "Aucune configuration disponible",
	"No events can be scheduled with your selected CRON expression.": "Aucun événement ne peut être planifié avec l'expression CRON que vous avez sélectionnée.",
	"No Hyper Protect Crypto Services instances found": "Aucune instance Hyper Protect Crypto Services n'a été trouvée",
	"No instances found": "Aucune instance trouvée",
	"No item matches the filters. Clear the filters and try again.": "Aucun élément ne correspond aux filtres. Effacez les filtres et réessayez.",
	"No items available to display. Select an instance and bucket to view objects.": "Aucun élément disponible à afficher. Sélectionnez une instance et un compartiment pour afficher les objets.",
	"No items match the current filter.": "Aucun élément ne correspond au filtre en cours.",
	"No keys available": "Aucune clé disponible",
	"No matches found. To create new tags, contact your tag administrator.": "Aucune correspondance n'a été trouvée. Pour créer de nouvelles étiquettes, contactez votre administrateur d'étiquettes.",
	"No matching options": "Aucune option correspondante",
	"No matching region ID's are available on this account. If you think this is an error, refresh the page or contact your administrator.": "Aucun ID de région correspondant n'est disponible sur ce compte. Si vous pensez qu'il s'agit d'une erreur, actualisez la page ou contactez votre administrateur.",
	"No plans found": "Aucun plan trouvé",
	"No regions available": "Aucune région disponible",
	"No resource groups available": "Aucun groupe de ressources disponible",
	"No secret available": "Aucun secret disponible",
	"No secret group available": "Aucun groupe de secrets disponible",
	"No service instance available": "Aucune instance de service disponible",
	"No valid version update options are available.": "Aucune option de mise à jour de version valide n'est disponible.",
	"Non-compliant": "Non conforme",
	None: None,
	"None available": "Aucun disponible",
	Normal: Normal,
	"Normal (48px)": "Taille normale (48 px)",
	"Not authorized": "Non autorisé",
	"Not ready": "Non prêt",
	Note: Note,
	Notification: Notification,
	November: November,
	"Object": "Objet",
	"Object storage": "Object Storage",
	"Object storage is used to store data about your location and backups for your location's clusters. <a>Learn more.</a>": "Le stockage d'objets est utilisé pour stocker des données relatives à l'emplacement et aux sauvegardes des clusters de votre emplacement. <a>En savoir plus.</a>",
	Objects: Objects,
	October: October,
	Off: Off,
	OK: OK,
	On: On,
	"Once a day": "Une fois par jour",
	"Once a month": "Une fois par mois",
	"Once a week": "Une fois par semaine",
	"Once a year": "Une fois par an",
	Open: Open,
	"Open dashboard": "Ouvrir le tableau de bord",
	"Open Dashboard": "Ouvrir le tableau de bord",
	"Open menu": "Ouvrir le menu",
	"Open page navigation menu": "Ouvrir le menu de navigation par page",
	"Open reference picker": "Ouvrir le sélecteur de référence",
	"Open tab list": "Ouvrir la liste d'onglets",
	Osaka: Osaka,
	"Overflow menu": "Menu déroulant dynamique",
	"Overflow Menu": "Menu déroulant dynamique",
	Overview: Overview,
	Packages: Packages,
	"page {{pageNumber}}": "page {{pageNumber}}",
	"Page Navigation": "Navigation entre les pages",
	"Page navigation menu": "Menu de navigation par page",
	"Page number": "Numéro de page",
	Pattern: Pattern,
	"Pay-As-You-Go": "Paiement à la carte",
	Pending: Pending,
	Plan: Plan,
	"Platform access": "Accès à la plateforme",
	"Platform logs from {{region}} will be sent to a new instance": "Les journaux de plateforme de {{region}} seront envoyés à une nouvelle instance",
	"Platform logs from {{region}} will be sent to an existing instance": "Les journaux de plateforme de {{region}} seront envoyés à une instance existante",
	"Platform logs from {{region}} will be sent to the target instance. <a>Learn more</a>": "Les journaux de plateforme de {{region}} seront envoyés à l'instance cible. <a>En savoir plus</a>",
	"Platform logs will be collected from enabled IBM Cloud services according to the defined routing scope.": "Les journaux de plateforme seront collectés à partir des services IBM Cloud activés, conformément à la portée de routage définie.",
	"Please <a>sign up</a> to create or <a>login</a> before applying the promo code.": "Veuillez <a>vous inscrire</a> pour créer un compte ou <a>vous connecter</a> avant d'appliquer le code promotionnel.",
	"Prefix filter": "Filtre de préfixes",
	Premium: Premium,
	"Preparing master, workers...": "Préparation du maître, des noeuds worker...",
	"Preparing master...": "Préparation du maître...",
	"Prerequisite services installed": "Services prérequis installés",
	Previous: Previous,
	"Previous page": "Page précédente",
	"Pricing Plans": "Plans de tarification",
	"prj-1, projct-2": "prj-1, projct-2",
	Product: Product,
	Products: Products,
	Project: Project,
	Projects: Projects,
	Property: Property,
	"Provide a more detailed description of the key. To protect your privacy, do not use personal data, such as your name or location, as a description. You cannot change this after key creation.": "Fournissez une description plus détaillée de la clé. Pour protéger votre vie privée, n'utilisez pas les données personnelles, telles que votre nom ou votre emplacement, comme description. Vous ne pourrez pas la modifier après la création de la clé.",
	provided: provided,
	Provider: Provider,
	"Provides visibility of the performance and health of your IBM Cloud powered resources application.": "Fournit une visibilité de la performance et de l'état de santé de votre application de ressources IBM Cloud.",
	Provisioning: Provisioning,
	Ready: Ready,
	"Ready to apply?": "Prêt à appliquer ?",
	Refresh: Refresh,
	"Refresh Cloud Object Storage instances": "Actualiser les instances Cloud Object Storage",
	"Refresh data": "Actualiser les données",
	"Refresh secrets": "Actualiser les secrets",
	region: region,
	Region: Region,
	Remove: Remove,
	"Remove sort": "Retirer le tri",
	"Rendering modify hooks is not supported to prevent unexpected resource changes.": "Le rendu des hooks de modification n'est pas pris en charge pour empêcher les modifications de ressource inattendues.",
	Renew: Renew,
	Repositories: Repositories,
	Requested: Requested,
	"Requesting creation...": "Demande de création...",
	Required: Required,
	Reservations: Reservations,
	Reset: Reset,
	"Reset filters": "Réinitialiser les filtres",
	"Reset to default": "Réinitialiser aux valeurs par défaut",
	"Reset zoom": "Réinitialiser le zoom",
	"Resource Configuration": "Configuration des ressources",
	"Resource group": "Groupe de ressources",
	"Resource group:": "Groupe de ressources :",
	"Resource list": "Liste de ressources",
	"Resource List": "Liste de ressources",
	resources: resources,
	Resources: Resources,
	"Resources not included in cost": "Ressources non incluses dans le coût",
	"Restricted access": "Accès restreint",
	Results: Results,
	"Retrying delete": "Nouvel essai de suppression",
	"Retrying deploy": "Nouvel essai de déploiement",
	"Revert {{resetCount}} to default": "Rétablir la valeur par défaut de {{resetCount}}",
	Review: Review,
	"Review access assignments to {{resourceDisplayName}}": "Vérifier les affectations d'accès à {{resourceDisplayName}}",
	"Review settings in Event Notifications": "Vérifiez les paramètres dans Event Notifications",
	"Review the following access group policies to ensure you're assigning the right level of access.": "Examinez les règles de groupe d'accès suivantes pour vérifier que vous affectez le niveau d'accès approprié.",
	"Rotation interval": "Intervalle de rotation",
	"Rotation policies determine the interval between automatic key rotations. An interval of one month, for example, means that a key will be rotated every 30 days. If the policy is already enabled, this means that an instance policy exists for this instance and if no other action is taken, the rotation interval shown will be applied to the key. If it is disabled, enable it to set a policy for this key.": "Les règles de rotation déterminent l'intervalle entre les rotations de clés automatiques. Un intervalle d'un mois, par exemple, signifie qu'une clé fera l'objet d'une rotation tous les 30 jours. Si la règle est déjà activée, cela signifie qu'une règle d'instance existe pour cette instance et si aucune autre action n'est effectuée, l'intervalle de rotation affiché sera appliqué à la clé. S'il est désactivé, activez-le pour définir une règle pour cette clé.",
	"Rotation policy": "Règle de rotation",
	"Rotation policy disabled": "Politique de rotation désactivée",
	"Route name": "Nom de la route",
	Routing: Routing,
	"Routing scope": "Portée du routage",
	"Row height": "Hauteur de ligne",
	"Sample not yet available": "L'exemple n'est pas encore disponible.",
	"Sao Paulo": "São Paulo",
	"Sat-Sun": "Samedi-Dimanche",
	Satellite: Satellite,
	"Satellite container": "Conteneur Satellite",
	"Satellite location": "Emplacement Satellite",
	"Satellite location base cost": "Coût de base de l'emplacement Satellite",
	"Satellite location base functionality": "Fonctionnalité de base d'emplacement Satellite",
	Saturday: Saturday,
	Save: Save,
	"Saving...": "Sauvegarde en cours...",
	Scanning: Scanning,
	Schedule: Schedule,
	"Schematics workspaces and other project data are stored in the selected region and resource group. <a>Learn more.</a>": "Les espaces de travail Schematics et les autres données de projet sont stockés dans la région et le groupe de ressources sélectionnés. <a>En savoir plus.</a>",
	"Schematics workspaces are provisioned in this region. Your project can still deploy resources to any region.": "Les espaces de travail Schematics sont mis à disposition dans cette région. Votre projet peut toujours déployer des ressources dans n'importe quelle région.",
	"Schematics workspaces are provisioned in this resource group. Your project can still deploy resources to any resource group.": "Les espaces de travail Schematics sont mis à disposition dans ce groupe de ressources. Votre projet peut toujours déployer des ressources dans n'importe quel groupe de ressources.",
	Search: Search,
	"Search in this instance": "Chercher dans cette instance",
	Secret: Secret,
	"Secret configured": "Secret configuré",
	"Secret group": "Groupe de secrets",
	"Secret type": "Type de secret",
	"Secrets Manager": "Secrets Manager",
	"Secure value": "Valeur sécurisée",
	"See details": "Voir les détails",
	Select: Select,
	"Select a location to see what steps you need to take next.": "Sélectionnez un emplacement pour voir les étapes à suivre ensuite.",
	"Select a project": "Sélectionner un projet",
	"Select a reference": "Sélectionner une référence",
	"Select a region": "Sélectionner une région",
	"Select a resource group": "Sélectionner un groupe de ressources",
	"Select a role to determine the level of access for the source service.": "Sélectionnez un rôle afin de déterminer le niveau d'accès pour le service source.",
	"Select a secret": "Sélectionner un secret",
	"Select a secret group": "Sélectionner un groupe de secrets",
	"Select a service instance": "Sélectionner une instance de service",
	"Select all {{totalRowCount}} items": "Sélectionner les {{totalRowCount}} éléments",
	"Select all rows on page": "Sélectionner toutes les lignes de la page",
	"Select an environment": "Sélectionner un environnement",
	"Select an existing configuration": "Sélectionner une configuration existante",
	"Select an IBM Cloud Monitoring instance to receive platform metrics": "Sélectionner une instance IBM Cloud Monitoring pour recevoir des métriques de plateforme",
	"Select an IBM Log Analysis instance to receive platform logs": "Sélectionner une instance IBM Log Analysis pour recevoir des journaux de plateforme",
	"Select an instance": "Sélectionner une instance KMS",
	"Select an instance to show keys": "Sélectionnez une instance pour afficher les clés",
	"Select an option...": "Sélectionnez une option...",
	"Select existing key": "Sélectionner une clé existante",
	"Select from Secrets Manager": "Sélectionner depuis Secrets Manager",
	"Select KMS instance": "Sélectionner l'instance KMS",
	"Select namespaces": "Sélectionner des espaces de noms",
	"Select one or more namespaces": "Sélectionner un ou plusieurs espaces de noms",
	"Select one or more projects": "Sélectionner un ou plusieurs projets",
	"Select prerequisites": "Sélectionner les prérequis",
	"Select projects": "Sélectionner des projets",
	"Select region and resource group": "Sélectionnez une région et un groupe de ressources",
	"Select row": "Sélectionner une ligne",
	"Select the <a>IBM Cloud region</a> that is closest to where your infrastructure resides to ensure low network latency.": "Sélectionnez la <a>région IBM Cloud</a> la plus proche de l'emplacement de votre infrastructure pour garantir un faible temps d'attente du réseau.",
	"Select the following tile to deploy it.": "Sélectionnez la vignette suivante pour la déployer.",
	"Send all audit events from enabled resources in {{region}}.": "Envoyer tous les événements d'audit des ressources activées dans {{region}}.",
	"Send all available audit events in this account.": "Envoyer tous les événements d'audit disponibles dans ce compte.",
	"Send events to": "Envoyer les événements à",
	"Send logs to": "Envoyer les journaux à",
	"Send test notification": "Envoyer une notification de test",
	Sending: Sending,
	"Sent!": "Envoi",
	September: September,
	Serverless: Serverless,
	"Serverless projects": "Projets sans serveur",
	Service: Service,
	"Service access": "Accès au service",
	"Service authorization": "Autorisation de service",
	"Service authorization is required to allow Activity Tracker Event Routing to communicate with Cloud Logs. Click <span>Authorize now</span> to create a policy scoped to all Cloud Logs resources in this account.": "L'autorisation de service est requise pour permettre à Activity Tracker Event Routing de communiquer avec Cloud Logs. Cliquez sur <span>Autoriser maintenant</span> pour créer une règle limitée à toutes les ressources Cloud Logs de ce compte.",
	"Service authorization required": "Autorisation de service requise",
	"Service instance": "Instance de service",
	"Service name": "Nom de service",
	"Service to service authorization must be provided for your instance. <a>Learn more</a>": "Une autorisation de service à service doit être fournie pour votre instance. <a>En savoir plus</a>",
	"Service to service authorization policy found": "Règle d'autorisation de service à service trouvée",
	"Service to service authorization policy needed": "Nécessité d'une règle d'autorisation de service à service",
	"Service type": "Type de service",
	"Service-to-service authorization couldn't be verified. Manually add and check the required roles.": "L'autorisation de service à service n'a pas pu être vérifiée. Ajoutez et vérifiez manuellement les rôles requis.",
	"Service-to-service authorization requirements are met.": "Les exigences d'autorisation de service à service sont satisfaites.",
	"Set an interval (in months)": "Définir un intervalle (en mois)",
	"Set key rotation policy": "Définir la règle de rotation des clés",
	"Set up auth": "Configurer l'authentification",
	Settings: Settings,
	"Short (32px)": "Petite taille (32 px)",
	"Show all filters": "Afficher tous les filtres",
	"Show code sample": "Afficher l'exemple de code",
	"Show environments information": "Afficher les informations sur les environnements",
	"Show error information": "Afficher les informations d'erreur",
	"Show information": "Afficher les informations",
	"Show less": "Afficher moins",
	"Show more": "Afficher plus",
	"Show more details": "Afficher plus de détails",
	"Show password": "Afficher le mot de passe",
	"Show tooltip": "Afficher l'infobulle",
	"Showing {{count}} item": "Affichage de {{count}} élément",
	"Showing {{count}} items": "Affichage de {{count}} éléments",
	Size: Size,
	"Small (32px)": "Petit (32px)",
	"Some events from {{serviceName}}:": "Quelques événements de {{serviceName}} :",
	"Something went wrong": "Un problème est survenu",
	"Something went wrong.": "Une erreur s'est produite.",
	"Something went wrong. Try reloading the page to see this information": "Une erreur s'est produite. Essayez de recharger la page pour voir ces informations",
	Sort: Sort,
	"Sort ascending": "Trier par ordre croissant",
	"Sort descending": "Trier par ordre décroissant",
	Source: Source,
	"Source Details": "Détail de la source",
	"Source for the service does not exist in Event Notifications instance. Contact your administrator.": "La source du service n'existe pas dans l'instance Event Notifications. Contactez votre administrateur.",
	"Source service": "Service source",
	"Specific namespaces not supported": "Certains espaces de noms non pris en charge",
	"Specific projects not supported": "Certains projets non pris en charge",
	Start: Start,
	"Start by creating a cluster that is just right to run your workloads.": "Commencez par créer un cluster parfaitement adapté pour exécuter vos charges de travail.",
	"Start date": "Date de début",
	"Starting at": "À partir de",
	"Starting costs are based on this resource configuration. You can edit configurations after you add this product to a project, which might impact costs.": "Les coûts initiaux sont basés sur cette configuration de ressources. Vous pouvez modifier les configurations après avoir ajouté ce produit à un projet, ce qui peut avoir un impact sur les coûts.",
	State: State,
	Status: Status,
	"status icon": "icône de statut",
	"Stay in pattern": "Rester dans le schéma",
	"Steps complete": "Étapes terminées",
	Storage: Storage,
	"Storage bucket (optional)": "Compartiment de stockage (facultatif)",
	"Storage configuration missing": "Configuration de stockage manquante",
	"Storage ready": "Stockage prêt",
	"Store, search, analyze, monitor, and alert on your IBM Cloud logging data and events.": "Stockez, recherchez, analysez, surveillez et alertez sur vos données et événements de journalisation IBM Cloud.",
	Submit: Submit,
	Subscription: Subscription,
	Success: Success,
	"success state": "état d'aboutissement",
	"Success! This promotion was applied to your account.": "Réussite ! Cette promotion a été appliquée à votre compte.",
	"Successfully created new Key Protect instance": "Création réussie d'une nouvelle instance Key Protect",
	Summary: Summary,
	Sunday: Sunday,
	"Support Plan": "Plan de support",
	"Switch to folders view": "Passer à la vue des dossiers",
	"Switch to objects view": "Passer à la vue des objets",
	Sydney: Sydney,
	"Syntax: ": "Syntaxe : ",
	tag: tag,
	"Tag '{{tagName}}' could not be created as the name is invalid.": "L'étiquette '{{tagName}}' n'a pas pu être créée car son nom n'est pas valide.",
	tags: tags,
	Tags: Tags,
	"Tags:": "Balises :",
	"Tags: (optional)": "Balises : (facultatif)",
	"Tall (64px)": "Grande taille (64 px)",
	"Target destination": "Destination cible",
	"Target location": "Emplacement cible",
	"Target name": "Nom de la cible",
	"Target selected": "Cible sélectionnée",
	"Target service instance": "Instance de service cible",
	"Target type": "Type de cible",
	"Template error": "Erreur liée au modèle",
	"Terms and conditions": "Dispositions",
	"Test notification": "Notification de test",
	"The address field is required.": "La zone d'adresse est obligatoire.",
	"The catalog window might have been blocked from opening.": "L'ouverture de la fenêtre du catalogue a peut-être été bloquée.",
	"The connected Event Notifications instance was deleted from the account. To continue using notifications, disconnect the current instance by clicking Disconnect from the menu ( ⋮ ). Then, connect another Event Notifications instance.": "L'instance d'Event Notifications connectée a été supprimée du compte. Pour continuer à utiliser les notifications, déconnectez l'instance en cours en cliquant sur Déconnexion dans le menu  ( ⋮ ). Ensuite, connectez une autre instance d'Event Notifications.",
	"The description should not contain any leading or trailing whitespace characters.": "La description ne doit pas contenir de caractères blancs de début ou de fin.",
	"The description should not exceed {{limit}} characters in length.": "La description ne doit pas dépasser {{limit}} caractères.",
	"The following access is required:": "L'accès suivant est requis :",
	"The following code preview displays the corresponding request as CLI commands. Use it as a starting point for writing your own automation. ": "L'aperçu de code suivant affiche la demande correspondante en tant que commandes CLI. Utilisez-le comme point de départ pour l'écriture de votre propre automatisation. ",
	"The following code preview displays the corresponding request as REST API calls. Use it as a starting point for writing your own automation. ": "L'aperçu de code suivant affiche la demande correspondante en tant qu'appels d'API REST. Utilisez-le comme point de départ pour l'écriture de votre propre automatisation. ",
	"The following code preview displays the corresponding request with Terraform. Use it as a starting point for writing your own automation. ": "L'aperçu de code suivant affiche la demande correspondante avec Terraform. Utilisez-le comme point de départ pour l'écriture de votre propre automatisation. ",
	"The following preview displays the corresponding request as code. Use it as a starting point for writing your own automation.": "L'aperçu suivant affiche la demande correspondante sous la forme de code. Utilisez-le comme point de départ pour l'écriture de votre propre automatisation.",
	"The following resources were not included in the cost estimate but might have an associated cost.": "Les ressources suivantes n'ont pas été incluses dans l'estimation de coût mais peuvent avoir un coût associé.",
	"The IAM role manager for {{serviceName}}": "Gestionnaire de rôle IAM pour {{serviceName}}",
	"The instance can't be accessed because a service to service authorization was removed from the account. Create an authorization with Event Source Manager access between {{sourceServiceName}} and Event Notifications.": "Impossible d'accéder à l'instance car une autorisation de service à service a été retirée du compte. Créez une autorisation d'accès au gestionnaire de sources d'événements entre {{sourceServiceName}} et Event Notifications.",
	"The list of namespaces can't be populated. Try again later.": "La liste des espaces de noms ne peut pas être dressée. Réessayez ultérieurement.",
	"The list of projects can't be populated. Try again later.": "La liste des projets ne peut pas être dressée. Réessayez ultérieurement.",
	"The name is required.": "Le nom est requis.",
	"The name must be {{max}} or fewer characters, begin with a letter, and contain only alphanumeric characters, '-', and '.'": "Le nom doit comporter au maximum {{max}} caractères, commencer par une lettre et contenir uniquement des caractères alphanumériques, le tiret ('-') et le point ('.').",
	"The name of a namespace can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.": "Le nom d'un espace de noms ne peut contenir que des lettres minuscules, des nombres et des tirets. Il ne peut pas commencer ou se terminer par un tiret et ne doit pas contenir plus de 63 caractères.",
	"The name of a project can include only lowercase letters, numbers, and dashes. The name can't start or end with a dash, and it must be at a maximum of 63 characters.": "Le nom d'un projet ne peut contenir que des lettres minuscules, des nombres et des tirets. Il ne peut pas commencer ou se terminer par un tiret et ne doit pas contenir plus de 63 caractères.",
	"The name should contain only alphanumeric, underscore, dashes and space.": "Le nom ne doit contenir que des caractères alphanumériques, des traits de soulignement, des tirets et des espaces.",
	"The name should not contain any special characters.": "Le nom ne doit pas contenir de caractères spéciaux.",
	"The name should not exceed {{limit}} characters in length.": "Le nom ne doit pas dépasser {{limit}} caractères.",
	"The region is required.": "La région est obligatoire.",
	"The resource group is required.": "Le groupe de ressources est obligatoire.",
	"The resource group window might have been blocked from opening.": "L'ouverture de la fenêtre du groupe de ressources a peut-être été bloquée.",
	"The tag name must be in a key:value format": "Le nom de l'étiquette doit être au format clé-valeur",
	"The tag name must be in a key:value format.": "Le nom de la balise doit être au format clé:valeur.",
	"The window might have been blocked from opening.": "L'ouverture de la fenêtre a peut-être été bloquée.",
	"There was a problem loading resource groups.": "Un problème s'est produit lors du chargement des groupes de ressources.",
	"These roles allow access for using the service and performing service API calls. Each role is customized by the selected service. Select all that apply. Refer to the service's documentation for more details.": "Ces rôles octroient un accès permettant d'utiliser le service et d'effectuer des appels d'API de service. Chaque rôle est personnalisé par le service sélectionné. Sélectionnez tous les rôles qui s'appliquent. Pour plus de détails, reportez-vous à la documentation du service.",
	"These roles are created by administrators in the account to customize how access is assigned to the service. Click the Actions for role icon to review what actions are mapped to this role.": "Les administrateurs créent ces rôles sur le compte afin de personnaliser comment l'accès est affecté au service. Cliquez sur l'icône Actions pour le rôle pour passer en revue les actions associées à ce rôle.",
	"These roles enable actions to be performed on platform resources, such as creating an instance, connecting instances to apps, and assigning user access. Select all that apply.": "Ces rôles permettent d'effectuer des actions sur des ressources de plateforme, telles que la création d'une instance, la connexion d'instances à des applications et l'affectation d'un accès utilisateur. Sélectionnez tous les rôles qui s'appliquent.",
	"This field is required": "Cette zone est requise",
	"This is currently not being sent on submit and is pending an update from the team responsible for the API.": "N'est actuellement pas envoyé lors de la soumission et est en attente d'une mise à jour de la part de l'équipe responsable de l'API.",
	"This is how your {{serviceName}} instance is referenced in Event Notifications": "Voici comment votre instance {{serviceName}} est référencée dans Event Notifications",
	"This project name \"{{name}}\" already exists, please choose another name.": "Ce nom de projet \"{{name}}\" existe déjà, veuillez choisir un autre nom.",
	"This section is under construction, come back later.": "Cette section est en construction. Revenez plus tard.",
	"This service requires additional storage assigned to the cluster. No matching storage configuration exists.": "Ce service requiert du stockage supplémentaire affecté au cluster. Il n'existe aucune configuration de stockage correspondante.",
	"This tag already exists. Choose another name for your tag.": "Cette étiquette existe déjà. Choisissez un autre nom pour votre étiquette.",
	"This value already exists.": "Cette valeur existe déjà.",
	"This view is not available for some account types": "Cette vue n'est pas disponible pour certains types de compte",
	"Three zone names are required": "Trois noms de zone sont requis",
	Thursday: Thursday,
	"To add HPCS encryption, follow these steps:": "Pour ajouter le chiffrement HPCS, procédez comme suit :",
	"To connect, the instance in this region must be configured for platform": "Pour que vous puissiez vous connecter, l'instance dans cette région doit être configurée pour la plateforme",
	"To control the notifications of the events generated by {{serviceName}}, connect to an Event Notifications instance. <a>Learn more</a>": "Pour contrôler les notifications des événements générés par {{serviceName}}, connectez-vous à une instance Event Notifications. <a>En savoir plus</a>",
	"To create a new HPCS key, follow the steps below...": "Pour créer une nouvelle clé HPCS, suivez les étapes ci-dessous...",
	Tokyo: Tokyo,
	Topics: Topics,
	Toronto: Toronto,
	Total: Total,
	"Total accounts": "Nombre de comptes total",
	"Total estimated cost": "Coût total estimé",
	"Transaction ID": "ID transaction",
	Trash: Trash,
	Trial: Trial,
	"Try again later, or contact your account administrator.": "Réessayez plus tard ou contactez votre administrateur de compte.",
	"Try again later.": "Réessayez ultérieurement.",
	"Try refreshing the page and then performing the action again to see if the problem persists. If so, make sure you're using a <a>supported browser</a> and check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.": "Essayez d'actualiser la page puis de relancer l'action pour vérifier si le problème persiste. Si c'est le cas, vérifiez que vous utilisez un <a>navigateur pris en charge</a> et consultez la <a>page de statut</a> pour voir si un autre problème s'est produit. Si le problème persiste, contactez le <a>support</a> pour obtenir de l'aide.",
	"Try waiting a few minutes and perform the action again to see if the problem persists. If so, check the <a>status page</a> to see if something else is going on. If you're still experiencing an issue reach out to <a>support</a> for help.": "Patientez quelques minutes et recommencez cette opération pour déterminer si le problème persiste. Si tel est le cas, consultez la <a>page de statut</a> pour déterminer si quelque chose d'autre se passe. Si le problème persiste, contactez le <a>support</a> pour obtenir de l'aide.",
	Tuesday: Tuesday,
	"Type \"{{clusterName}}\" to confirm": "Tapez \"{{clusterName}}\" pour confirmer",
	"Type \"{{name}}\" to confirm": "Entrez \"{{name}}\" pour confirmer",
	"Unable to configure activity tracker event routing.": "Impossible de configurer le routage des événements Activity Tracker",
	"Unable to configure Activity Tracker integration.": "Impossible de configurer l'intégration Activity Tracker.",
	"Unable to configure Logging integration.": "Impossible de configurer l'intégration de la journalisation.",
	"Unable to configure logging.": "Impossible de configurer la journalisation.",
	"Unable to connect your service to Event Notifications service. Try again later.": "Impossible de connecter votre service au service Event Notifications. Réessayez ultérieurement.",
	"Unable to create authorization policy.": "Impossible de créer une règle d'autorisation.",
	"Unable to create Satellite location": "Impossible de créer l'emplacement Satellite",
	"Unable to create the service to service policy at this time. Refresh the page, or try again later.": "Impossible de créer la règle de service à service pour le moment. Actualisez la page ou faites une nouvelle tentative ultérieurement.",
	"Unable to delete cluster": "Impossible de supprimer le cluster",
	"Unable to disconnect Event Notifications instance. Refresh the page, or try again later.": "Impossible de déconnecter l'instance Event Notifications. Actualisez la page ou faites une nouvelle tentative ultérieurement.",
	"Unable to get cluster data": "Impossible d'obtenir les données de cluster",
	"Unable to get Event Notifications instance details. Refresh the page, or try again later.": "Impossible d'obtenir les détails de l'instance Event Notifications. Actualisez la page ou faites une nouvelle tentative ultérieurement.",
	"Unable to get storage instances.": "Impossible d'obtenir les instances de stockage.",
	"Unable to list clusters.": "Impossible de répertorier les clusters.",
	"Unable to list locations.": "Impossible de répertorier les emplacements.",
	"Unable to load Activity Tracker service catalog data": "Impossible de charger les données du catalogue de services Activity Tracker",
	"Unable to load Cloud Logs service catalog data": "Impossible de charger les données du catalogue de services Cloud Logs",
	"Unable to load cluster details.": "Impossible de charger les détails de cluster.",
	"Unable to load cluster update version options.": "Impossible de charger les options de version de mise à jour de cluster.",
	"Unable to load event routing settings": "Impossible de charger les paramètres de routage des événements",
	"Unable to load event routing target instances": "Impossible de charger les instances cibles de routage d'événements",
	"Unable to load event routing target instances.": "Impossible de charger les instances cibles de routage d'événements.",
	"Unable to load event routing targets": "Impossible de charger les cibles de routage d'événements",
	"Unable to load event routing targets.": "Impossible de charger les cibles de routage d'événements.",
	"Unable to load IBM Cloud locations data": "Impossible de charger les données d'emplacement IBM Cloud",
	"Unable to load logging instances": "Impossible de charger les instances de journalisation",
	"Unable to load logging instances.": "Impossible de charger les instances de journalisation.",
	"Unable to load logging service catalog data": "Impossible de charger les données du catalogue du service de journalisation",
	"Unable to load logs routing targets": "Impossible de charger les journaux des cibles de routage",
	"Unable to load logs routing targets.": "Impossible de charger les cibles de routage des journaux.",
	"Unable to perform": "Exécution impossible",
	"Unable to retrieve cluster details": "Impossible d'extraire les détails du cluster",
	"Unable to retrieve data": "Impossible d'extraire les données",
	"Unable to retrieve location information.": "Impossible d'extraire les informations d'emplacement.",
	"Unable to retrieve project configurations.": "Impossible d'extraire les configurations du projet.",
	"Unable to send test notification to Event Notifications instance. Try again later.": "Impossible d'envoyer une notification de test à l'instance Event Notifications. Réessayez ultérieurement.",
	"Unable to send the test notification to Event Notifications instance. Check if Topics are setup in Event Notifications.": "Impossible d'envoyer la notification de test à l'instance Event Notifications. Vérifiez si les rubriques sont configurées dans Event Notifications.",
	"Unable to update cluster version.": "Impossible de mettre à jour la version du cluster.",
	Unknown: Unknown,
	"unknown state": "état inconnu",
	"Unselect all rows": "Désélectionner toutes les lignes",
	"Unselect row": "Désélectionner une ligne",
	Unsupported: Unsupported,
	"Unsupported version. Update the version to continue to receive support.": "Version non prise en charge. Mettez à jour la version pour continuer à bénéficier du support.",
	"Upcoming scheduled events in your timezone": "Evènements planifiés à venir dans votre fuseau horaire",
	Update: Update,
	"Update available": "Mise à jour disponible",
	"Update cluster version": "Mettre à jour la version du cluster",
	"Update tags": "Mettre à jour les étiquettes",
	"Update version": "Version de mise à jour",
	"Updating...": "Mise à jour en cours...",
	Upgrade: Upgrade,
	"Upgrade your account to view the billing period.": "Mettez à niveau votre compte pour afficher la période de facturation.",
	"Usage based charges apply per gigabyte of audit events ingested.": "Des frais basés sur l'utilisation s'appliquent par gigaoctet d'événements d'audit ingérés.",
	"Usage based charges apply per gigabyte of logs ingested.": "Des frais basés sur l'utilisation s'appliquent par gigaoctet de journaux ingérés.",
	"Usage costs": "Coûts d'utilisation",
	"Use a secret to securely and centrally manage your credentials for authentication. <a>Learn more</a>": "Utilisez un secret pour gérer de manière sécurisée et centralisée vos identifiants pour l'authentification. <a>En savoir plus</a>",
	"Use a secret?": "Utiliser un secret ?",
	"Use existing": "Utiliser l'existant",
	"Use key aliases to easily identify your keys. A key alias is a unique and easily recognizable custom name.": "Utilisez des alias de clé pour identifier facilement vos clés. Un alias de clé est un nom personnalisé unique et facilement reconnaissable.",
	"Use tags to organize your resources. If your user tags are billing related, consider writing tags as key:value pairs to help group related tags, such as": "Utilisez des étiquettes pour organiser vos ressources. Si vos étiquettes utilisateur sont liées à la facturation, pensez à les créer sous la forme de paires clé:valeur pour regrouper plus facilement des étiquettes connexes, comme",
	"Use the options below to choose the item that the reference will be created for.": "Utilisez les options ci-dessous pour choisir l'élément pour lequel la référence sera créée.",
	"User evaluation required": "Evaluation de l'utilisateur requise",
	"User permissions failure": "Échec des autorisations de l'utilisateur",
	"User tags": "Etiquettes utilisateur",
	"User tags (optional": "Balises utilisateur (facultatif)",
	"User tags are visible account-wide. Avoid including sensitive data in the tag name.": "Les étiquettes utilisateur sont visibles à l'échelle du compte. Evitez d'inclure des données sensibles dans le nom des étiquettes.",
	Value: Value,
	"Value must be a valid array (Ex. [\"array\"]). To specify a null array use \"__NOT_SET__\"": "La valeur doit être un tableau valide (par exemple [\"array\"]). Pour spécifier un tableau null, utilisez \"__NOT_SET__\"",
	Values: Values,
	"Verify that the following services have been installed on the location: {{missingServices}}.": "Vérifiez que les services suivants ont été installés à l'emplacement : {{missingServices}}.",
	Version: Version,
	View: View,
	"View all": "Affichage global",
	"View audit events": "Afficher les événements d'audit",
	"View docs": "Afficher la documentation",
	"View error information": "Afficher les informations sur l'erreur",
	"View logging": "Afficher la journalisation",
	"View-only mode": "Mode visualisation seulement",
	"VPC Gen1": "VPC Génération 1",
	"VPC Gen2": "VPC Génération 2",
	Warning: Warning,
	"warning state": "état d'avertissement",
	"Washington DC": "Washington DC",
	Wednesday: Wednesday,
	"What you will need:": "Eléments requis :",
	"What's the purpose of this project?": "Quel est le but de ce projet ?",
	"When you delete the cluster, all worker nodes, apps, and containers are permanently deleted. This action cannot be undone. Before you proceed, make sure to back up all required data and configuration files.": "Lorsque vous supprimez le cluster, l'ensemble des noeuds worker, applications et conteneurs est définitivement supprimé. Cette action ne peut pas être annulée. Avant de continuer, veillez à sauvegarder toutes les données et tous les fichiers de configuration requis.",
	"Worker count": "Nombre de noeuds worker",
	Workloads: Workloads,
	"Wrong Syntax": "Syntaxe incorrecte",
	Yes: Yes,
	"You already have a location with this name. Enter a unique name.": "Vous disposez déjà d'un emplacement du même nom. Entrez un nom unique.",
	"You already have an instance of Security and Compliance Center. To see results, you must schedule your first scan by creating an attachment.": "Vous disposez déjà d'une instance de Security and Compliance Center. Pour afficher les résultats, vous devez planifier votre première analyse en créant une pièce jointe.",
	"You are unable to modify this policy due to your level of access for the policy's resource. If you'd like the ability to modify, contact your administrator to update your resource access.": "Vous ne pouvez pas modifier cette règle en raison de votre niveau d'accès à la ressource de la règle. Si vous souhaitez avoir la possibilité de la modifier, contactez votre administrateur pour mettre à jour votre accès aux ressources.",
	"You can find a list of resources here once you create them.": "Vous trouverez une liste de ressources ici une fois que vous les aurez créées.",
	"You can find your resource details here after you create them.": "Vous trouverez les détails de vos ressources ici après les avoir créées.",
	"You can find your resources here after you create them.": "Retrouvez vos ressources ici après les avoir créées.",
	"You can find your Satellite locations here after you create them.": "Vous pouvez trouver vos emplacements Satellite ici après les avoir créés.",
	"You do not have access to any resource groups.": "Vous n'avez accès à aucun groupe de ressources.",
	"You do not have access to any resource groups. <a>Create</a> a resource group.": "Vous n'avez accès à aucun groupe de ressources. <a>Créer</a> un groupe de ressources.",
	"You do not have permission to edit tags. Contact your administrator if you require greater access.": "Vous n'êtes pas autorisé à modifier des étiquettes. Contactez votre administrateur si vous avez besoin d'un accès plus étendu.",
	"You don't have the correct access to add a configuration in \"{{project}}\"": "Vous ne disposez pas des droits d'accès appropriés pour ajouter une configuration dans \"{{project}}\"",
	"You have restricted access and may not be able to add or remove tags. Contact your administrator if you require greater access.": "Vous disposez d'un accès restreint et vous risquez de ne pas pouvoir ajouter ou supprimer des étiquettes. Contactez votre administrateur si vous avez besoin d'un accès plus étendu.",
	"You haven't connected an Event Notifications service instance yet.": "Vous n'avez pas encore connecté d'instance de service Event Notifications.",
	"You may also <a>create an instance</a>.": "Vous pouvez également <a>créer une instance</a>.",
	"You may also create a new one.": "Vous pouvez aussi en créer un.",
	"You may have context-based restrictions or IAM policies enabled. Contact your account administrator.": "Des restrictions contextuelles ou des règles IAM peuvent être activées. Contactez votre administrateur de compte.",
	"You must have at least one active root key. Try creating a new one.": "Vous devez disposer d'au moins une clé racine active. Essayez d'en créer un nouveau.",
	"You need at least 1 topic to send a test notification.": "Vous avez besoin d'au moins 1 rubrique pour envoyer une notification de test.",
	"You need the Editor or Administrator role on the IBM Cloud Projects service to this project. <a>Assign yourself access</a> or request access from your account administrator.": "Vous devez disposer du rôle Éditeur ou Administrateur sur le service IBM Cloud Projects pour ce projet. <a>Affectez-vous l'accès</a> ou demandez-le à l'administrateur de votre compte.",
	"You're adding tags to:": "Vous ajoutez des étiquettes à :",
	"You're editing tags for:": "Vous éditez des étiquettes pour :",
	"You're not authorized to connect to this instance. Verify your permissions or contact your administrator.": "Vous n'êtes pas autorisé à vous connecter à cette instance. Vérifiez vos droits ou contactez votre administrateur.",
	"You're using the newest version of the API server. There are no updates available at this time.": "Vous utilisez la version la plus récente du serveur d'API. Aucune mise à jour n'est actuellement disponible.",
	"You've reached the maximum number of tags that you can attach at a single time. To attach more tags, save your changes first.": "Vous avez atteint le nombre maximal d'étiquettes que vous pouvez connecter simultanément. Pour connecter plusieurs étiquettes, sauvegardez d'abord vos modifications.",
	"Your API server is updating to version {{version}}. After it finishes you can update your worker nodes to the same version.": "Votre serveur d'API est en cours de mise à jour vers la version {{version}}. Une fois qu'elle est terminée, vous pouvez mettre à jour vos noeuds worker vers la même version.",
	Zone: Zone,
	Zones: Zones,
	"Zoom in image": "Zoom avant sur l'image",
	"Zoom out image": "Zoom arrière sur l'image"
};

export { About, Access, Account, Actions, Active, Add, Address, Advanced, Aliases, All, Apply, April, Arbitrary, Assign, August, BNPP_EU, Back, Basic, CLI, Cancel, Category, Classic, Clear, Close, Clusters, Complete, Completed, Compliance, Compliant, Configuration, Configure, Confirm, Connect, Connected, Connecting, Containers, Country, Create, Created, Creating, Critical, Current, Custom, Dallas, Datacenter, Datacenters, December, Delete, Deleting, Deploying, Disabled, Disconnect, Docs, Documentation, Done, Download, Draft, Edit, Enabled, Encryption, End, Enterprise, Establish, Expired, Failed, February, Filter, Filters, Finalizing, Frankfurt, Free, Friday, Geography, Help, Hour, IAM, ID, Images, Inactive, Incomplete, Information, Infrastructure, Instance, Instances, Integrations, Invalid, January, July, June, Key, Launch, Lite, Loading, Location, Locations, Logging, London, March, May, Metro, Minute, Monday, Monitoring, Month, Name, Namespace, Namespaces, Next, No, None, Normal, Note, Notification, November, OK, Objects, October, Off, On, Open, Osaka, Overview, Packages, Pattern, Pending, Plan, Premium, Previous, Product, Products, Project, Projects, Property, Provider, Provisioning, Ready, Refresh, Region, Remove, Renew, Repositories, Requested, Required, Reservations, Reset, Resources, Results, Review, Routing, Satellite, Saturday, Save, Scanning, Schedule, Search, Secret, Select, Sending, September, Serverless, Service, Settings, Size, Sort, Source, Start, State, Status, Storage, Submit, Subscription, Success, Summary, Sunday, Sydney, Tags, Thursday, Tokyo, Topics, Toronto, Total, Trash, Trial, Tuesday, Unknown, Unsupported, Update, Upgrade, Value, Values, Version, View, Warning, Wednesday, Workloads, Yes, Zone, Zones, all, code, fr as default, hour, hr, mo, more, provided, region, resources, tag, tags };
